import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Preloader from "./components/Preloader";
import Navbar from "./components/Navbar";
import Home from "./components/Home";
import PackagesSection from "./components/PackagesSection";
import ProjectsSection from "./components/ProjectsSection";
import StatsSection from "./components/StatsSection";
import AboutSection from "./components/AboutSection";
import WorkSection from "./components/WorkSection";
import Footer from "./components/Footer";
import ContactsPage from "./components/ContactsPage";
import PrivacyPolicy from "./components/PrivacyPolicy";
import CookieConsent from "./components/CookieConsent";
import CallToAction from "./components/CallToAction";
import ScrollToHashElement from "./components/ScrollToHashElement";
import TermsAndConditions from "./components/TermsAndConditions";
import FAQ from "./components/FAQ";
import WhatsAppButton from "./components/WhatsAppButton";
import NotFound from "./components/NotFound";
import { Routes, Route } from "react-router-dom";
import "./App.css";

const STRIP_SERVICES = [
  "Branding",
  "Tráfego Pago",
  "Gestão de Redes Sociais",
  "Website & E-commerce",
  "Marketing de Influência",
  "Eventos & Ativações de Marca",
];

function App() {
  const [loading, setLoading] = useState(true);
  const { i18n } = useTranslation();

  useEffect(() => {
    const saved = localStorage.getItem("cmLang");
    if (!saved) {
      const legacy = localStorage.getItem("selectedLanguage");
      if (legacy === "en") i18n.changeLanguage("en");
    }
  }, [i18n]);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1500);
    return () => clearTimeout(timer);
  }, []);

  if (loading) return <Preloader />;

  return (
    <div className="App">
      <Navbar />

      <ScrollToHashElement />

      <Routes>
        <Route
          path="/"
          element={
            <>
              <main>
                <section id="homepage">
                  <Home />
                </section>

                <StatsSection />

                <section id="servicos">
                  <ProjectsSection />
                </section>

                <div className="cm-strip cm-strip--solo" aria-hidden="true">
                  <div className="cm-strip__track">
                    {[...Array(3)]
                      .flatMap(() => STRIP_SERVICES)
                      .map((s, i) => (
                        <span key={i} className="cm-strip__item">
                          {s} <span className="cm-strip__sep">✦</span>
                        </span>
                      ))}
                  </div>
                </div>

                <PackagesSection />

                <section id="sobre">
                  <AboutSection />
                </section>

                <section id="clientes">
                  <WorkSection />
                </section>
              </main>

              <section id="cta">
                <CallToAction />

                <div
                  className="cm-strip cm-strip--dark cm-strip--solo"
                  aria-hidden="true"
                >
                  <div className="cm-strip__track">
                    {[...Array(15)].map((_, i) => (
                      <span
                        key={i}
                        className="cm-strip__item cm-strip__item--dark"
                      >
                        <img
                          src="/logo.jpeg"
                          alt=""
                          className="cm-strip__logo"
                        />
                      </span>
                    ))}
                  </div>
                </div>
              </section>

              <Footer />
            </>
          }
        />

        <Route path="/contactos" element={<ContactsPage />} />
        <Route path="/privacidade" element={<PrivacyPolicy />} />
        <Route path="/condicoes-venda" element={<TermsAndConditions />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="*" element={<NotFound />} />
      </Routes>

      <CookieConsent />
      <WhatsAppButton />
    </div>
  );
}

export default App;
